import { getQueryStringVariable } from './getQueryStringVariable';

export function getQueryStringToken() {
	let token = getQueryStringVariable("token");
	if (token) {
		if (window.appConfig) {
			window.appConfig['QUERY_STRING_TOKEN'] = token;
		}
	}else{
		token = window.appConfig?.['QUERY_STRING_TOKEN'];
	}
	return token;
}
